import { render, staticRenderFns } from "./QuickLinkList.vue?vue&type=template&id=4e09a990"
import script from "./QuickLinkList.vue?vue&type=script&lang=ts"
export * from "./QuickLinkList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports